import { render, staticRenderFns } from "./SnippetCopyButton.vue?vue&type=template&id=2423c36b&"
import script from "./SnippetCopyButton.vue?vue&type=script&lang=js&"
export * from "./SnippetCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports